import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">GTO Preflop</Link>
            <p>© {new Date().getFullYear()} Peka Software. All rights reserved.</p>
          </div>
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>App</h4>
              <ul>
                <li><a href="https://apps.apple.com/us/app/gto-preflop/id1629141961" className="ios-store-link" target="_blank" rel="noopener noreferrer">Download iOS</a></li>
                <li><a href="https://play.google.com/store/apps/details?id=com.gtopreflopfree.gtopreflopfree" className="android-store-link" target="_blank" rel="noopener noreferrer">Download Android</a></li>
                <li><Link to="/marketing">About</Link></li>
                <li><Link to="/support">Support</Link></li>
                <li><a href="https://affiliate.gtopre.com" target="_blank" rel="noopener noreferrer">Affiliate Program</a></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/terms">Terms</Link></li>
                <li><Link to="/privacy">Privacy</Link></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>Tools</h4>
              <ul>
                <li><Link to="/icm_calculator">ICM Calculator</Link></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>Other Apps</h4>
              <ul>
                <li><a href="https://apps.apple.com/za/app/gto-pocket-trainer/id6448717874" className="ios-trainer-link" target="_blank" rel="noopener noreferrer">GTO Pocket Trainer</a></li>
                <li><a href="https://play.google.com/store/apps/details?id=com.gtopre.gto_pocket_trainer" className="android-trainer-link" style={{ display: 'none' }} target="_blank" rel="noopener noreferrer">GTO Pocket Trainer</a></li>
                <li><a href="https://apps.apple.com/us/app/mystery-bounty-poker-solver/id6677032655" className="ios-bounty-link" target="_blank" rel="noopener noreferrer">Mystery Bounty Solver</a></li>
                <li><a href="https://play.google.com/store/apps/details?id=com.pekasoftware.mystery_bounty_poker_solver" className="android-bounty-link" style={{ display: 'none' }} target="_blank" rel="noopener noreferrer">Mystery Bounty Solver</a></li>
                <li><a href="https://apps.apple.com/uy/app/gto-postflop-solver/id6738748434" className="ios-postflop-link" target="_blank" rel="noopener noreferrer">GTO Postflop Solver</a></li>
                <li><a href="https://play.google.com/store/apps/details?id=com.pekasoftware.gtopostflopsolver.gto_postflop_solver&hl=en" className="android-postflop-link" style={{ display: 'none' }} target="_blank" rel="noopener noreferrer">GTO Postflop Solver</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 